<template>
  <v-container>
    <h2
      class="hidden-lg-and-up mx-5 mb-5 font-weight-light"
      style="color: #333"
    >{{ this.$route.name }}</h2>

    <v-card class="ma-5" color="white" light>
      <v-card-title>
        SLIPI
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchSlipi"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="congregationSlipi" :search="searchSlipi"></v-data-table>
    </v-card>

    <v-card class="ma-5" color="white" light>
      <v-card-title>
        KWITANG
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchKwitang"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="congregationKwitang" :search="searchKwitang"></v-data-table>
    </v-card>

    <v-card class="ma-5" color="white" light>
      <v-card-title>
        BSD
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchBSD"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="congregationBSD"
        :search="searchBSD"
        @click:row="selectRow"
      ></v-data-table>
    </v-card>

    <v-card class="ma-5" color="white" light>
      <v-card-title>
        TANGERANG
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchTangerang"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="congregationTangerang" :search="searchTangerang"></v-data-table>
    </v-card>

    <v-card class="ma-5" color="white" light>
      <v-card-title>
        BEKASI
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchBekasi"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="congregationBekasi" :search="searchBekasi"></v-data-table>
    </v-card>

    <div class="text-center">
      <v-dialog v-model="dialog" width="500">
        <v-card light>
          <v-card-title
            v-model="person"
            class="headline grey lighten-2"
            primary-title
          >{{ person.name == null ? 'Name' : person.name }}</v-card-title>

          <v-img src="@/assets/person.png" contain height="200" class="mt-8 mb-8"></v-img>

          <v-card-text
            class="mt-5"
          >Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false" class="mr-2">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import congregationSlipi from "@/data/slipi/congregation.json";
import congregationKwitang from "@/data/kwitang/congregation.json";
import congregationBSD from "@/data/bsd/congregation.json";
import congregationTangerang from "@/data/tangerang/congregation.json";
import congregationBekasi from "@/data/bekasi/congregation.json";

export default {
  name: "Congregation",
  data() {
    return {
      dialog: false,
      person: {},
      searchSlipi: "",
      searchKwitang: "",
      searchBSD: "",
      searchTangerang: "",
      searchBekasi: "",
      headers: [
        {
          text: "NIJ",
          align: "start",
          value: "nij"
        },
        { text: "Name", value: "name" },
        { text: "Birth Date (YYYY-MM-DD)", value: "birthdate" },
        { text: "Address", value: "address" },
        { text: "Phone", value: "phone" },
        { text: "Email", value: "email" }
      ],
      congregationSlipi: congregationSlipi,
      congregationKwitang: congregationKwitang,
      congregationBSD: congregationBSD,
      congregationTangerang: congregationTangerang,
      congregationBekasi: congregationBekasi
    };
  },
  methods: {
    selectRow(person) {
      this.person = person;
      this.dialog = true;
    }
  }
};
</script>